import "./requestGeo.scss";
import Image from "../../assets/img.png";
import Map from "../../assets/map.png";
import Target from "../../assets/target.png";
import { useContext } from "react";
import { AuthContext } from "../../context/authContext";
import api from "../../services/api";
import { useState } from "react";

const RequestGeo = (props) => {
  const {currentUser} = useContext(AuthContext)
  const [msisdn, setMsisdn] = useState("");

  const handleGeoRequest = async (e) => {
    e.preventDefault();
    const data = {
      msisdn: msisdn,
    };
    try {
      // const res = await api.post(`/api/osint/otc_request/`, data);
      // FIXME: try to understand why we fail with POST in this request
      const res = await api.get(`/api/osint/otc_request/`, {params: data});
      console.log(res);
      props.forceRefresh();
    } catch (err) {
      console.error(err);
    }
  }
  
  return (
    <div className="requestGeo">
     <form>
      <div className="container">
        <div className="top">
          <img src={currentUser.profilePic} alt=""/>
          <input type="text" id="msisdn" name="msisdn" 
          placeholder={"enter a msisdn number"} 
          value={msisdn} 
          onChange={(e) => setMsisdn(e.target.value)} />
        </div>
        <hr />
        <div className="bottom">
          <div className="left">
            
            <div className="item">
              <img src={Map} alt="" />
              <span>Execute query -&gt;</span>
            </div>
          </div>
          <div className="right">
            <button onClick={handleGeoRequest}>RequestGeo</button>
          </div>
        </div>
      </div>
      </form>
    </div>
  );
};

export default RequestGeo;
